// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"c4d16be1","120":"b269e2e4","348":"481b3a68","354":"4d4b094c","424":"c6bd5d95","436":"db4cb09a"}[chunkId] + ".chunk.js";
};